// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__a3Is2","modalForm":"UpgradeEpcsModal_modalForm__3pRX8","modalFooter":"UpgradeEpcsModal_modalFooter__bL2Ec"};